import {
  Flex, HStack, Link, Text,
} from '@chakra-ui/react';
import {
  useNetworkCharacteristicsKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import ReportHeader from './ReportHeader';

const subheader = 'Roads, Cycleways and Bridges';
const informationSource = {
  title: 'Network Physical Characteristics',
  content: [
    {
      title: 'Network Length Growth km / % (% Year Annual Avg)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The average of the annual change in road network length for the last ten financial years, reported in km.
    </Text>
    <Text fontSize="inherit" mb={2}>
      The average of the percentage change in road network length per year for the last ten financial years, reported in km. The percentage change per year is calculated as the change in the year divided by the total length at the start of the year.
    </Text>
    <Text mb={2}>Road Efficiency Group Te Ringa Maimoa has calculated this result.</Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA, physical statistics - roads</Link>
  </Text>,
    },
  ],
};

function NetworkPhysicalCharacteristicsReportHeader({ ...rest }) {
  const { data: networkPhysicalCharacteristicsData, isLoadingKpi } = useNetworkCharacteristicsKPI();

  return (
    <ReportHeader
      title="Network Physical Characteristics"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <HStack mr={3} spacing={0}>
          <CircleIndicator
            size={60}
            colour={networkPhysicalCharacteristicsData?.percentage !== undefined ? 'gray.700' : null}
            value={networkPhysicalCharacteristicsData?.percentage !== undefined ? `${roundKpiValue(networkPhysicalCharacteristicsData?.percentage, 0.1, 2, 'max', 1)}%` : undefined}
            isLoading={isLoadingKpi || !networkPhysicalCharacteristicsData}
          />
          <Text>
            (
            {networkPhysicalCharacteristicsData?.value.toFixed(1)}
            km)
          </Text>
        </HStack>
        <Text fontWeight="bold" color="gray" fontSize="sm">
          Network Length Growth
          <br />
          <Text as="span" fontSize="xs" color="gray">
            (
            {networkPhysicalCharacteristicsData?.averageYearRange}
            {' '}
            Annual Avg)
          </Text>
        </Text>
      </Flex>
    </ReportHeader>
  );
}

export default NetworkPhysicalCharacteristicsReportHeader;
